import { createReducer, on } from '@ngrx/store';
import { DATA_FORMAT_DEFAULT_STATE } from 'ChartApp/ts/apps/scatter-plot/state/constants';
import { ScatterPlotPlotType } from 'ChartApp/ts/enums/scatter-plot-common.enum';
import { setDataFormatAggregation, setDataFormatFillMethod, setDataFormatFrequency } from './data-format.actions';
import { setScatterPlot } from 'ChartApp/ts/apps/scatter-plot/state/scatter-plot.actions';
/* eslint-disable unused-imports/no-unused-vars-ts */
export const dataFormat = createReducer({}, on(setDataFormatAggregation, (state, { aggregation }) => {
    return { ...state, aggregation };
}), on(setDataFormatFillMethod, (state, { fillMethod }) => {
    return { ...state, fillMethod };
}), on(setDataFormatFrequency, (state, { frequency }) => {
    if (!frequency) {
        return DATA_FORMAT_DEFAULT_STATE;
    }
    return { ...state, frequency };
}), on(setScatterPlot, (state, action) => {
    if (action.scatterPlot.plotType === ScatterPlotPlotType.timeseries) {
        return action.scatterPlot.dataFormat;
    }
    return state;
}));
